module.exports = __webpack_public_path__ + "img/alentour2.1b05dc90.jpg";